import _ from 'lodash'
import BUSINESS_THYRISTOR_CONFIG from './config'
import axios from 'axios'
import API from '../../core/api'

class BusinessDiodeClass {
    constructor() {
        this.DOM = {
            section: BUSINESS_THYRISTOR_CONFIG.section,
            pic: null,
            family: null,
            part_number: null,
            it_rms_a: null,
            vrrm: null,
            igt_q1: null,
            dvdt: null,
            itsm_a: null,
            outline: null,
            data_paper: null,
            app_notes: null,
            tech_notes: null,
            packaging: null,
            literature: null,
            marking: null,
            download: null,
            zoom: null,
            product_line: null
        }

        this.pdfSVG = null
        this.path = null
        this.product = null
        this.DOM.section ? this.init() : null
    }

    init() {
        this._dom()
        this._path()
        this._get()
    }

    _dom() {
        this.DOM.pic = _.select( '.col--pic .pic img' )
        this.DOM.family = _.select( '.col--data .product-family' )
        this.DOM.part_number = _.select( '.col--data .product-part-number' )
        this.DOM.it_rms_a = _.select( '.col--data .product-it_rms_a' )
        this.DOM.vrrm = _.select( '.col--data .product-vrrm' )
        this.DOM.igt_q1 = _.select( '.col--data .product-igt_q1' )
        this.DOM.dvdt = _.select( '.col--data .product-dvdt' )
        this.DOM.itsm_a = _.select( '.col--data .product-itsm_a' )
        this.DOM.outline = _.select( '.col--data .product-outline' )
        this.DOM.data_paper = _.select( '.col--data .product-data-paper' )
        this.DOM.app_notes = _.select( '.extra__data .product-app-notes' )
        this.DOM.tech_notes = _.select( '.extra__data .product-tech-notes' )
        this.DOM.packaging = _.select( '.extra__data .product-packaging' )
        this.DOM.literature = _.select( '.extra__data .product-literature' )
        this.DOM.marking = _.select( '.extra__data .product-marking' )
        this.DOM.download = _.select( '.option--download' )
        this.DOM.zoom = _.select( '.option--zoom' )
        this.DOM.product_line = _.select('.breadcrumb__line')
        this.DOM.breadcrumb_pn = _.select('.breadcrumb__part-number')
        this.pdfSVG = `<img src="${this.DOM.section.getAttribute( 'data-pdf' ) }"/>`
    }

    _path() {
        this.path = this.DOM.section.getAttribute( 'data-resources' )
    }

    _get() {
        axios.get( this.DOM.section.getAttribute( 'data-source' ))
        .then( ( response ) => {
            this.product = response.data.filter( e => (e['Part number']).replace(/ /g,'') == this.DOM.section.getAttribute( 'data-product' ) )
        })
        .then( () => {
            this._draw()
        })
    }

    _draw() {
        let product = this.product[0]
        let img = `${product['Image'].split('.').slice(0, -1).join('.')}.jpg`
        /* Product main */
        this.DOM.pic.src = `${this.path}semiconductores/img/${img}`
        this.DOM.pic.alt = img
        this.DOM.family.textContent = `${product['Family']}`
        this.DOM.part_number.textContent = `${product['Part number']}`
        this.DOM.breadcrumb_pn.textContent = `${product['Part number']}`
        this.DOM.download.href = `${this.path}semiconductores/img/${product['Image']}`
        this.DOM.zoom.href = `${this.path}semiconductores/img/${product['Image']}`
        this.DOM.product_line.textContent = `${product['Product line']}`
        product['IT (RMS) (A)'] != '' ? this.DOM.it_rms_a.textContent = `${product['IT (RMS) (A)']}` : this.DOM.it_rms_a.parentNode.style.display = 'none'
        product['VRRM/VDRM (V)'] != '' ? this.DOM.vrrm.textContent = `${product['VRRM/VDRM (V)']}` : this.DOM.vrrm.parentNode.style.display = 'none'
        product['IGT Q1-3 (mA)'] != '' ? this.DOM.igt_q1.textContent = `${product['IGT Q1-3 (mA)']}` : this.DOM.igt_q1.parentNode.style.display = 'none'
        product['dv/dt(min) (V/µs)'] != '' ? this.DOM.dvdt.textContent = `${product['dv/dt(min) (V/µs)']}` : this.DOM.dvdt.parentNode.style.display = 'none'
        product['ITSM (A)'] != '' ? this.DOM.itsm_a.textContent = `${product['ITSM (A)']}` : this.DOM.itsm_a.parentNode.style.display = 'none'
        product['Outline'] != '' ? this.DOM.outline.textContent = `${product['Outline']}` : this.DOM.outline.parentNode.style.display = 'none'
        if ( product['Data sheet'] != '' ) {
            this.DOM.data_paper.href = `${this.path}semiconductores/data-sheets/${product['Data sheet']}`
            this.DOM.data_paper.innerHTML = `${this.pdfSVG}<span>${product['Data sheet']}</span>`
        } else {
            this.DOM.data_paper.parentNode.style.display = 'none'
        }
        /* Product extra data */
        // App notes
        let app_notes = '';
        product['Application note 1'] != '' ? app_notes += `<li><a href="${this.path}semiconductores/application-notes/${product['Application note 1']}" target="_blank">${this.pdfSVG}<span>${product['Application note 1']}</span></a></li>` : null
        product['Application note 2'] != '' ? app_notes += `<li><a href="${this.path}semiconductores/application-notes/${product['Application note 2']}" target="_blank">${this.pdfSVG}<span>${product['Application note 2']}</span></a></li>` : null
        app_notes != '' ? this.DOM.app_notes.innerHTML = app_notes : this.DOM.app_notes.parentNode.style.display = 'none'
        // Tech notes
        let tech_notes = '';
        product['Technical note 1'] != '' ? tech_notes += `<li><a href="${this.path}semiconductores/application-notes/${product['Technical note 1']}" target="_blank">${this.pdfSVG}<span>${product['Technical note 1']}</span></a></li>` : null
        product['Technical note 2'] != '' ? tech_notes += `<li><a href="${this.path}semiconductores/application-notes/${product['Technical note 2']}" target="_blank">${this.pdfSVG}<span>${product['Technical note 2']}</span></a></li>` : null
        tech_notes != '' ? this.DOM.tech_notes.innerHTML = tech_notes : this.DOM.tech_notes.parentNode.style.display = 'none'
        // Packaging
        let packaging = '';
        product['Packaging information'] != '' ? packaging += `<li><a href="${this.path}semiconductores/application-notes/${product['Packaging information']}" target="_blank">${this.pdfSVG}<span>${product['Packaging information']}</span></a></li>` : null
        packaging != '' ? this.DOM.packaging.innerHTML = packaging : this.DOM.packaging.parentNode.style.display = 'none'
        // Literature
        let literature = '';
        product['Product literature 1'] != '' ? literature += `<li><a href="${this.path}semiconductores/data-sheets/${product['Product literature 1']}" target="_blank">${this.pdfSVG}<span>${product['Product literature 1']}</span></a></li>` : null
        product['Product literature 2'] != '' ? literature += `<li><a href="${this.path}semiconductores/data-sheets/${product['Product literature 2']}" target="_blank">${this.pdfSVG}<span>${product['Product Literature 2']}</span></a></li>` : null
        literature != '' ? this.DOM.literature.innerHTML = literature : this.DOM.literature.parentNode.style.display = 'none'
        // Marking
        let marking = '';
        product['Marking'] != '' ? marking += `<li><a href="${this.path}semiconductores/data-sheets/${product['Marking']}" target="_blank">${this.pdfSVG}<span>${product['Marking']}</span></a></li>` : null
        marking != '' ? this.DOM.marking.innerHTML = marking : this.DOM.marking.parentNode.style.display = 'none'
        this._getProductLineUrl()

    }

    _getProductLineUrl () {
        let product = this.product[0]['Product line']
        let data = new FormData()
        data.append('product_line', product)
        console.log(product)
        API.post('semiconductors/product-line', 
            data
        )
        .then((response) => {
            this.DOM.product_line.href = response.data
        })
        .catch((error) => {
            console.log(error)
        })
    }
}

const BUSINESS_DIODE = new BusinessDiodeClass()
export default BUSINESS_DIODE